import styled from 'styled-components';
import { media } from '../../../../../../styles/Qtheme';

export const MobileMenuButton = styled.button`
    all: unset;
    display: none;
    @media ${media.desktop} {
        display: block;
    }
`;
